var map = {
	"./aboutpic/about-profile-img-top.png": "T9cp",
	"./aboutpic/about-profile-img.jpg": "OgEm",
	"./aboutpic/cert1.png": "2Oa/",
	"./aboutpic/cert10.png": "EVxU",
	"./aboutpic/cert11.png": "grkJ",
	"./aboutpic/cert12.png": "bxCo",
	"./aboutpic/cert2.png": "+luM",
	"./aboutpic/cert3.png": "OETR",
	"./aboutpic/cert4.png": "R5xB",
	"./aboutpic/cert5.png": "kyDZ",
	"./aboutpic/cert6.png": "/SUu",
	"./aboutpic/cert7.png": "iIQA",
	"./aboutpic/cert8.png": "Wh+B",
	"./aboutpic/cert9.png": "62VC",
	"./aboutpic/exhibit-1.jpg": "NdzN",
	"./aboutpic/exhibit-2.jpg": "+x3I",
	"./aboutpic/exhibit-3.jpg": "0+rd",
	"./aboutpic/exhibit-4.jpg": "jRfO",
	"./aboutpic/map.png": "dAuO",
	"./aboutpic/mapL.png": "lkwg",
	"./aboutpic/mapR.png": "d/6P",
	"./aboutpic/top-img.jpg": "+nk5",
	"./add.png": "Zarb",
	"./call.png": "B7Kp",
	"./companyprofilepic/2017.jpg": "beXc",
	"./companyprofilepic/2018.jpg": "O1KD",
	"./companyprofilepic/2019.jpg": "v4Oc",
	"./companyprofilepic/2021.12-2022.11.jpg": "3Zrl",
	"./companyprofilepic/2021.7.15.jpg": "89dV",
	"./companyprofilepic/2022.12.jpg": "MKDt",
	"./companyprofilepic/2023.11.jpg": "qzoL",
	"./companyprofilepic/2023.3.jpg": "3xmg",
	"./companyprofilepic/banner.jpg": "CxsO",
	"./companyprofilepic/bannermachine.png": "iIyq",
	"./companyprofilepic/bottomimg.png": "7oA1",
	"./companyprofilepic/cp-1.jpg": "CLhD",
	"./companyprofilepic/unit-1.png": "5Eq8",
	"./companyprofilepic/unit-2.png": "+Tt3",
	"./companyprofilepic/unit-3.png": "HDcC",
	"./companyprofilepic/unit-4.png": "i7U+",
	"./companyprofilepic/unit-5.png": "cILh",
	"./companyprofilepic/unit-6.png": "VdUE",
	"./companyprofilepic/unit-7.jpg": "8DkS",
	"./contactpic/contactCenter.jpg": "JkGP",
	"./contactpic/down-1.jpg": "gW07",
	"./contactpic/down-2.jpg": "hYbi",
	"./contactpic/down-3.jpg": "f3HV",
	"./contactpic/map_logo.png": "Jmm/",
	"./contactpic/top-img.jpg": "Uy1S",
	"./contactpic/us-1.jpg": "z00f",
	"./contactpic/us-2.jpg": "zHPb",
	"./emailicon-1.png": "JWPg",
	"./emailicon.png": "93e3",
	"./fonts/Alibaba-PuHuiTi-R.woff": "gees",
	"./fonts/Alibaba-PuHuiTi-R.woff2": "8Mp2",
	"./footerpic/footer-1.png": "vNFM",
	"./footerpic/footer-2.png": "+Oz3",
	"./footerpic/footer-3.png": "9xex",
	"./footerpic/footer-4.png": "6UmP",
	"./footerpic/footer-5.png": "hoT0",
	"./footerpic/footer-6.png": "gfnw",
	"./footerpic/footer-7.png": "WHdE",
	"./footerpic/footer-8.png": "hcqv",
	"./footerpic/footerDetailPic/pd_detail_2.jpg": "IzGh",
	"./footerpic/footerDetailPic/pd_detail_3.jpg": "cD3l",
	"./footerpic/footerDetailPic/pd_detail_4.jpg": "gfm2",
	"./footerpic/footerDetailPic/pd_detail_5.jpg": "rvel",
	"./footerpic/footerDetailPic/pd_detail_6.jpg": "HIYd",
	"./footerpic/footerDetailPic/pd_detail_7.jpg": "sALp",
	"./footerpic/footerDetailPic/pd_detail_8.jpg": "TpTl",
	"./footerpic/footerDetailPic/pd_top_2.jpg": "YaFa",
	"./footerpic/footerDetailPic/pd_top_3.jpg": "o6Tb",
	"./footerpic/footerDetailPic/pd_top_4.jpg": "xF27",
	"./footerpic/footerDetailPic/pd_top_5.jpg": "uyJK",
	"./footerpic/footerDetailPic/pd_top_6.jpg": "E+wh",
	"./footerpic/footerDetailPic/pd_top_7.jpg": "gszc",
	"./footerpic/footerDetailPic/pd_top_8.jpg": "TGxk",
	"./footerpic/footeron-1.png": "GzEi",
	"./footerpic/footeron-2.png": "UvzB",
	"./footerpic/footeron-3.png": "pb7z",
	"./footerpic/footeron-4.png": "kfll",
	"./footerpic/footeron-5.png": "8dSU",
	"./footerpic/footeron-6.png": "XSyP",
	"./footerpic/footeron-7.png": "oppn",
	"./footerpic/footeron-8.png": "NIIm",
	"./goback.png": "Y0px",
	"./lgimg-1.png": "JQ7o",
	"./lgimg.png": "+kur",
	"./link.png": "6tLM",
	"./logo-1.png": "s+4m",
	"./logo.png": "7Otq",
	"./logoEn-1.png": "F0bJ",
	"./logoEn.png": "H1TL",
	"./newspic/20241108_6.jpg": "Htly",
	"./newspic/newstop.jpg": "WGOu",
	"./phoneicon-1.png": "41jG",
	"./phoneicon.png": "gQgs",
	"./productspic/ECS.jpg": "FGDL",
	"./productspic/MM.jpg": "msFD",
	"./productspic/MT.jpg": "7k+G",
	"./productspic/aepic/aepic-1.jpg": "rPwP",
	"./productspic/aepic/aepic-10.jpg": "atNm",
	"./productspic/aepic/aepic-11.jpg": "t4lg",
	"./productspic/aepic/aepic-12.jpg": "SEwH",
	"./productspic/aepic/aepic-13.jpg": "7RHC",
	"./productspic/aepic/aepic-14.jpg": "zuPd",
	"./productspic/aepic/aepic-15.jpg": "VOR6",
	"./productspic/aepic/aepic-16.jpg": "Lbyy",
	"./productspic/aepic/aepic-17.jpg": "3pk3",
	"./productspic/aepic/aepic-18.jpg": "MfJA",
	"./productspic/aepic/aepic-19.jpg": "45Jx",
	"./productspic/aepic/aepic-2.jpg": "Z01P",
	"./productspic/aepic/aepic-20.jpg": "QPAx",
	"./productspic/aepic/aepic-21.jpg": "Pg5j",
	"./productspic/aepic/aepic-22.jpg": "+MpH",
	"./productspic/aepic/aepic-23.jpg": "sTfJ",
	"./productspic/aepic/aepic-24.jpg": "Ndpp",
	"./productspic/aepic/aepic-25-2.jpg": "5BKd",
	"./productspic/aepic/aepic-25.jpg": "aXCW",
	"./productspic/aepic/aepic-26-2.jpg": "Bmah",
	"./productspic/aepic/aepic-26.jpg": "/MHH",
	"./productspic/aepic/aepic-27-2.jpg": "SGur",
	"./productspic/aepic/aepic-27.jpg": "HqxK",
	"./productspic/aepic/aepic-28-2.jpg": "Qq2u",
	"./productspic/aepic/aepic-28.jpg": "rZSL",
	"./productspic/aepic/aepic-3.jpg": "UIOZ",
	"./productspic/aepic/aepic-4.jpg": "GYUE",
	"./productspic/aepic/aepic-5.jpg": "iy1G",
	"./productspic/aepic/aepic-6.jpg": "olLq",
	"./productspic/aepic/aepic-7.jpg": "8Aud",
	"./productspic/aepic/aepic-8.jpg": "pn78",
	"./productspic/aepic/aepic-9.jpg": "XnTI",
	"./productspic/arthroscopypic/arthroscopy-01.jpg": "g9X8",
	"./productspic/arthroscopypic/arthroscopy-02.jpg": "+pN6",
	"./productspic/arthroscopypic/arthroscopy-03.jpg": "/9V/",
	"./productspic/arthroscopypic/arthroscopy-04.jpg": "nfD9",
	"./productspic/arthroscopypic/arthroscopy-05.jpg": "NXwt",
	"./productspic/arthroscopypic/arthroscopy-06.jpg": "Ef+R",
	"./productspic/arthroscopypic/arthroscopy-07.jpg": "ottW",
	"./productspic/arthroscopypic/arthroscopy-08.jpg": "n3d0",
	"./productspic/arthroscopypic/arthroscopy-09.jpg": "+CcT",
	"./productspic/arthroscopypic/arthroscopy-10.jpg": "auVY",
	"./productspic/arthroscopypic/arthroscopy-11.jpg": "B4Nn",
	"./productspic/arthroscopypic/arthroscopy-12.jpg": "nyi3",
	"./productspic/arthroscopypic/arthroscopy-13.jpg": "zmGb",
	"./productspic/arthroscopypic/arthroscopy-14.jpg": "lwDi",
	"./productspic/arthroscopypic/arthroscopy-15.jpg": "leov",
	"./productspic/arthroscopypic/arthroscopy-16.jpg": "YO7j",
	"./productspic/arthroscopypic/arthroscopy-17.jpg": "GGu7",
	"./productspic/arthroscopypic/arthroscopy-18.jpg": "gVO/",
	"./productspic/arthroscopypic/arthroscopy-19.jpg": "mfCp",
	"./productspic/arthroscopypic/arthroscopy-20.jpg": "wsjK",
	"./productspic/arthroscopypic/arthroscopy-21.jpg": "Wg+x",
	"./productspic/arthroscopypic/arthroscopy-22.jpg": "MZM2",
	"./productspic/arthroscopypic/arthroscopy-23.jpg": "+b4U",
	"./productspic/arthroscopypic/arthroscopy-detail-01.jpg": "0dL2",
	"./productspic/arthroscopypic/arthroscopy-detail-02.jpg": "s8Li",
	"./productspic/arthroscopypic/arthroscopy-detail-03.jpg": "4OZu",
	"./productspic/arthroscopypic/arthroscopy-detail-04.jpg": "cZjt",
	"./productspic/arthroscopypic/arthroscopy-detail-05.jpg": "pusP",
	"./productspic/arthroscopypic/arthroscopy-detail-06.jpg": "QkEo",
	"./productspic/arthroscopypic/arthroscopy-detail-07.jpg": "/Kzk",
	"./productspic/arthroscopypic/arthroscopy-detail-08.jpg": "OWOE",
	"./productspic/arthroscopypic/arthroscopy-detail-09.jpg": "OzuZ",
	"./productspic/arthroscopypic/arthroscopy-detail-10.jpg": "5EP5",
	"./productspic/arthroscopypic/arthroscopy-detail-11.jpg": "A+IF",
	"./productspic/arthroscopypic/arthroscopy-detail-12.jpg": "Vt/H",
	"./productspic/arthroscopypic/arthroscopy-detail-13.jpg": "/IOR",
	"./productspic/arthroscopypic/arthroscopy-detail-14.jpg": "eLtf",
	"./productspic/arthroscopypic/arthroscopy-detail-15.jpg": "uCtE",
	"./productspic/arthroscopypic/arthroscopy-detail-16.jpg": "Ls03",
	"./productspic/arthroscopypic/arthroscopy-detail-17.jpg": "zwCj",
	"./productspic/arthroscopypic/arthroscopy-detail-18.jpg": "03+k",
	"./productspic/arthroscopypic/arthroscopy-detail-19.jpg": "xWOA",
	"./productspic/arthroscopypic/arthroscopy-detail-20.jpg": "MRaT",
	"./productspic/arthroscopypic/arthroscopy-detail-21.jpg": "5S49",
	"./productspic/arthroscopypic/arthroscopy-detail-22.jpg": "VM6+",
	"./productspic/arthroscopypic/arthroscopy-detail-23.jpg": "LqV6",
	"./productspic/celoscopepic/celoscope-1.jpg": "XkY2",
	"./productspic/celoscopepic/celoscope-10.jpg": "eT24",
	"./productspic/celoscopepic/celoscope-11.jpg": "JMKf",
	"./productspic/celoscopepic/celoscope-12.jpg": "BVY0",
	"./productspic/celoscopepic/celoscope-13.jpg": "LFjS",
	"./productspic/celoscopepic/celoscope-14.jpg": "ajoD",
	"./productspic/celoscopepic/celoscope-15.jpg": "8tjb",
	"./productspic/celoscopepic/celoscope-16.jpg": "ygIe",
	"./productspic/celoscopepic/celoscope-17.jpg": "+4xb",
	"./productspic/celoscopepic/celoscope-18.jpg": "zE1l",
	"./productspic/celoscopepic/celoscope-19.jpg": "qqoy",
	"./productspic/celoscopepic/celoscope-2.jpg": "ogqJ",
	"./productspic/celoscopepic/celoscope-20.jpg": "0cLl",
	"./productspic/celoscopepic/celoscope-21.jpg": "BU1w",
	"./productspic/celoscopepic/celoscope-22.jpg": "Dq9V",
	"./productspic/celoscopepic/celoscope-23.jpg": "TTC3",
	"./productspic/celoscopepic/celoscope-24.jpg": "pTFd",
	"./productspic/celoscopepic/celoscope-25.jpg": "PYTe",
	"./productspic/celoscopepic/celoscope-26.jpg": "EvgQ",
	"./productspic/celoscopepic/celoscope-27.jpg": "R61u",
	"./productspic/celoscopepic/celoscope-28.jpg": "Lh63",
	"./productspic/celoscopepic/celoscope-29.jpg": "lpwF",
	"./productspic/celoscopepic/celoscope-3.jpg": "Lzcb",
	"./productspic/celoscopepic/celoscope-30.jpg": "vlvs",
	"./productspic/celoscopepic/celoscope-31.jpg": "K1vZ",
	"./productspic/celoscopepic/celoscope-32.jpg": "vIar",
	"./productspic/celoscopepic/celoscope-33.jpg": "FFO+",
	"./productspic/celoscopepic/celoscope-34.jpg": "BjIo",
	"./productspic/celoscopepic/celoscope-35.jpg": "L3OJ",
	"./productspic/celoscopepic/celoscope-36.jpg": "N+VE",
	"./productspic/celoscopepic/celoscope-37.jpg": "NQhS",
	"./productspic/celoscopepic/celoscope-38.jpg": "vXqn",
	"./productspic/celoscopepic/celoscope-4.jpg": "9Nry",
	"./productspic/celoscopepic/celoscope-5.jpg": "2oiI",
	"./productspic/celoscopepic/celoscope-6.jpg": "AC2K",
	"./productspic/celoscopepic/celoscope-7.jpg": "7YV1",
	"./productspic/celoscopepic/celoscope-8.jpg": "KWVc",
	"./productspic/celoscopepic/celoscope-9.jpg": "BpRi",
	"./productspic/celoscopepic/celoscope-detail-10.jpg": "Lq3n",
	"./productspic/celoscopepic/celoscope-detail-11.jpg": "hY0d",
	"./productspic/celoscopepic/celoscope-detail-12.jpg": "PflL",
	"./productspic/celoscopepic/celoscope-detail-13.jpg": "5MnA",
	"./productspic/celoscopepic/celoscope-detail-14.jpg": "of7J",
	"./productspic/celoscopepic/celoscope-detail-15.jpg": "Wi1V",
	"./productspic/celoscopepic/celoscope-detail-16.jpg": "vgQB",
	"./productspic/celoscopepic/celoscope-detail-17.jpg": "TLeH",
	"./productspic/celoscopepic/celoscope-detail-18.jpg": "29oS",
	"./productspic/celoscopepic/celoscope-detail-19.jpg": "bQ8D",
	"./productspic/celoscopepic/celoscope-detail-2.jpg": "7aaR",
	"./productspic/celoscopepic/celoscope-detail-20.jpg": "ZuNb",
	"./productspic/celoscopepic/celoscope-detail-21.jpg": "ig3f",
	"./productspic/celoscopepic/celoscope-detail-22.jpg": "aYLF",
	"./productspic/celoscopepic/celoscope-detail-23.jpg": "WhWK",
	"./productspic/celoscopepic/celoscope-detail-24.jpg": "wDXM",
	"./productspic/celoscopepic/celoscope-detail-25.jpg": "twxH",
	"./productspic/celoscopepic/celoscope-detail-26.jpg": "QgIx",
	"./productspic/celoscopepic/celoscope-detail-27.jpg": "QrmR",
	"./productspic/celoscopepic/celoscope-detail-28.jpg": "f6+U",
	"./productspic/celoscopepic/celoscope-detail-29.jpg": "PZud",
	"./productspic/celoscopepic/celoscope-detail-3.jpg": "gpeV",
	"./productspic/celoscopepic/celoscope-detail-30.jpg": "xmE7",
	"./productspic/celoscopepic/celoscope-detail-31.jpg": "HOQz",
	"./productspic/celoscopepic/celoscope-detail-32.jpg": "ef8x",
	"./productspic/celoscopepic/celoscope-detail-33.jpg": "5dCP",
	"./productspic/celoscopepic/celoscope-detail-34.jpg": "oiH4",
	"./productspic/celoscopepic/celoscope-detail-35.jpg": "lFFX",
	"./productspic/celoscopepic/celoscope-detail-36.jpg": "2u2s",
	"./productspic/celoscopepic/celoscope-detail-37.jpg": "Q1ei",
	"./productspic/celoscopepic/celoscope-detail-38.jpg": "kDLh",
	"./productspic/celoscopepic/celoscope-detail-4.jpg": "fziA",
	"./productspic/celoscopepic/celoscope-detail-5.jpg": "m7G0",
	"./productspic/celoscopepic/celoscope-detail-6.jpg": "HQ7C",
	"./productspic/celoscopepic/celoscope-detail-7.jpg": "RWbc",
	"./productspic/celoscopepic/celoscope-detail-8.jpg": "iK0P",
	"./productspic/celoscopepic/celoscope-detail-9.jpg": "JlIU",
	"./productspic/detailpic/4k-img.jpg": "r6wT",
	"./productspic/detailpic/HD-img.jpg": "VFcD",
	"./productspic/detailpic/U1668H/top-img.jpg": "rXOJ",
	"./productspic/detailpic/UC3880/UC3880-4K.jpg": "ZwlO",
	"./productspic/detailpic/UC3880/UC3880-HD.jpg": "6+43",
	"./productspic/detailpic/UC3880/normal.jpg": "cokV",
	"./productspic/detailpic/UC3880/switch-1.jpg": "gwsU",
	"./productspic/detailpic/UC3880/switch-2.jpg": "ETAE",
	"./productspic/detailpic/UC3880/switch-3.jpg": "TWjR",
	"./productspic/detailpic/UC3880/top-img-HD.jpg": "0JHI",
	"./productspic/detailpic/UC3880/top-img.jpg": "DAXE",
	"./productspic/detailpic/UL168/UL168-2.jpg": "WvA7",
	"./productspic/detailpic/UL168/top-img.jpg": "iDSC",
	"./productspic/detailpic/UY300/UY300-1.jpg": "M7e/",
	"./productspic/detailpic/camera/camera-1.jpg": "e2oJ",
	"./productspic/entpic/ent-1.jpg": "aHIw",
	"./productspic/entpic/ent-10.jpg": "/W7d",
	"./productspic/entpic/ent-100.jpg": "q/W0",
	"./productspic/entpic/ent-11.jpg": "xB/6",
	"./productspic/entpic/ent-12.jpg": "Omov",
	"./productspic/entpic/ent-13.jpg": "tMHc",
	"./productspic/entpic/ent-14.jpg": "21Rc",
	"./productspic/entpic/ent-15.jpg": "hV+R",
	"./productspic/entpic/ent-16.jpg": "/3eX",
	"./productspic/entpic/ent-17.jpg": "DEtQ",
	"./productspic/entpic/ent-18.jpg": "y9Xc",
	"./productspic/entpic/ent-19.jpg": "PoP0",
	"./productspic/entpic/ent-2.jpg": "wkG1",
	"./productspic/entpic/ent-20.jpg": "V6iO",
	"./productspic/entpic/ent-21.jpg": "OQPG",
	"./productspic/entpic/ent-22.jpg": "8Wpl",
	"./productspic/entpic/ent-23.jpg": "AzPH",
	"./productspic/entpic/ent-24.jpg": "wOeV",
	"./productspic/entpic/ent-25.jpg": "4eXf",
	"./productspic/entpic/ent-26.jpg": "dqr1",
	"./productspic/entpic/ent-27.jpg": "tv/q",
	"./productspic/entpic/ent-28.jpg": "mw++",
	"./productspic/entpic/ent-29.jpg": "n6js",
	"./productspic/entpic/ent-3.jpg": "0d8a",
	"./productspic/entpic/ent-30.jpg": "uuIo",
	"./productspic/entpic/ent-31.jpg": "Gb+z",
	"./productspic/entpic/ent-32.jpg": "S7fL",
	"./productspic/entpic/ent-33.jpg": "6sO4",
	"./productspic/entpic/ent-34.jpg": "Droe",
	"./productspic/entpic/ent-35.jpg": "NrQe",
	"./productspic/entpic/ent-36.jpg": "dzTb",
	"./productspic/entpic/ent-37.jpg": "EQq0",
	"./productspic/entpic/ent-38.jpg": "yy6q",
	"./productspic/entpic/ent-39.jpg": "/XHc",
	"./productspic/entpic/ent-4.jpg": "IEkT",
	"./productspic/entpic/ent-40.jpg": "OoQX",
	"./productspic/entpic/ent-41.jpg": "XWer",
	"./productspic/entpic/ent-42.jpg": "cDfy",
	"./productspic/entpic/ent-43.jpg": "5eRv",
	"./productspic/entpic/ent-44.jpg": "iOVU",
	"./productspic/entpic/ent-45.jpg": "bwi/",
	"./productspic/entpic/ent-46.jpg": "6NLQ",
	"./productspic/entpic/ent-47.jpg": "AL0n",
	"./productspic/entpic/ent-48.jpg": "lXo8",
	"./productspic/entpic/ent-49.jpg": "Pzgs",
	"./productspic/entpic/ent-5.jpg": "Ilm3",
	"./productspic/entpic/ent-50.jpg": "wP8/",
	"./productspic/entpic/ent-51.jpg": "Hl21",
	"./productspic/entpic/ent-52.jpg": "VKQ+",
	"./productspic/entpic/ent-53.jpg": "4rNN",
	"./productspic/entpic/ent-54.jpg": "+CJH",
	"./productspic/entpic/ent-55.jpg": "Erm3",
	"./productspic/entpic/ent-56.jpg": "eHvt",
	"./productspic/entpic/ent-57.jpg": "6c/Z",
	"./productspic/entpic/ent-58.jpg": "bPxr",
	"./productspic/entpic/ent-59.jpg": "octH",
	"./productspic/entpic/ent-6.jpg": "3Wf5",
	"./productspic/entpic/ent-60.jpg": "SWzp",
	"./productspic/entpic/ent-61.jpg": "00dk",
	"./productspic/entpic/ent-62.jpg": "84la",
	"./productspic/entpic/ent-63.jpg": "8rqk",
	"./productspic/entpic/ent-64.jpg": "dCa+",
	"./productspic/entpic/ent-65.jpg": "c5wN",
	"./productspic/entpic/ent-66.jpg": "rhkR",
	"./productspic/entpic/ent-67.jpg": "vDAO",
	"./productspic/entpic/ent-68.jpg": "fTRN",
	"./productspic/entpic/ent-69.jpg": "tMZD",
	"./productspic/entpic/ent-7.jpg": "Inrl",
	"./productspic/entpic/ent-70.jpg": "Y9c6",
	"./productspic/entpic/ent-71.jpg": "rz89",
	"./productspic/entpic/ent-72.jpg": "gMt3",
	"./productspic/entpic/ent-73.jpg": "GwKx",
	"./productspic/entpic/ent-74.jpg": "I9+i",
	"./productspic/entpic/ent-75.jpg": "hQa6",
	"./productspic/entpic/ent-76.jpg": "syJu",
	"./productspic/entpic/ent-77.jpg": "NVEl",
	"./productspic/entpic/ent-78.jpg": "9M4S",
	"./productspic/entpic/ent-79.jpg": "Sbhc",
	"./productspic/entpic/ent-8.jpg": "mgr3",
	"./productspic/entpic/ent-80.jpg": "DhX1",
	"./productspic/entpic/ent-81.jpg": "hWFS",
	"./productspic/entpic/ent-82.jpg": "7yGw",
	"./productspic/entpic/ent-83.jpg": "kInt",
	"./productspic/entpic/ent-84.jpg": "WU2N",
	"./productspic/entpic/ent-85.jpg": "d7Hf",
	"./productspic/entpic/ent-86.jpg": "s+k3",
	"./productspic/entpic/ent-87.jpg": "ZCSm",
	"./productspic/entpic/ent-88.jpg": "cacZ",
	"./productspic/entpic/ent-89.jpg": "7i3/",
	"./productspic/entpic/ent-9.jpg": "mtQI",
	"./productspic/entpic/ent-90.jpg": "r46+",
	"./productspic/entpic/ent-91.jpg": "mpqS",
	"./productspic/entpic/ent-92.jpg": "xhkG",
	"./productspic/entpic/ent-93.jpg": "20v1",
	"./productspic/entpic/ent-94.jpg": "xWYY",
	"./productspic/entpic/ent-95.jpg": "M6Tt",
	"./productspic/entpic/ent-96.jpg": "4V3C",
	"./productspic/entpic/ent-97.jpg": "ofcA",
	"./productspic/entpic/ent-98.jpg": "A8RG",
	"./productspic/entpic/ent-99.jpg": "X1/0",
	"./productspic/entpic/ent-detail-1.jpg": "SIHN",
	"./productspic/entpic/ent-detail-10.jpg": "2Ylf",
	"./productspic/entpic/ent-detail-100.jpg": "D0QK",
	"./productspic/entpic/ent-detail-11.jpg": "ZnNp",
	"./productspic/entpic/ent-detail-12.jpg": "bdKt",
	"./productspic/entpic/ent-detail-13.jpg": "h6s7",
	"./productspic/entpic/ent-detail-14.jpg": "I25B",
	"./productspic/entpic/ent-detail-15.jpg": "l5Ul",
	"./productspic/entpic/ent-detail-16.jpg": "Xy5R",
	"./productspic/entpic/ent-detail-17.jpg": "i9Jc",
	"./productspic/entpic/ent-detail-18.jpg": "GPjh",
	"./productspic/entpic/ent-detail-19.jpg": "/qV7",
	"./productspic/entpic/ent-detail-2.jpg": "gDk5",
	"./productspic/entpic/ent-detail-20.jpg": "9LHx",
	"./productspic/entpic/ent-detail-21.jpg": "7ntt",
	"./productspic/entpic/ent-detail-22.jpg": "o+pX",
	"./productspic/entpic/ent-detail-23.jpg": "rPkJ",
	"./productspic/entpic/ent-detail-24.jpg": "JwCY",
	"./productspic/entpic/ent-detail-25.jpg": "rZPj",
	"./productspic/entpic/ent-detail-26.jpg": "nUS+",
	"./productspic/entpic/ent-detail-27.jpg": "8r2Z",
	"./productspic/entpic/ent-detail-28.jpg": "e+nI",
	"./productspic/entpic/ent-detail-29.jpg": "ay7T",
	"./productspic/entpic/ent-detail-3.jpg": "Nl0h",
	"./productspic/entpic/ent-detail-30.jpg": "I28z",
	"./productspic/entpic/ent-detail-31.jpg": "FSlp",
	"./productspic/entpic/ent-detail-32.jpg": "H2MV",
	"./productspic/entpic/ent-detail-33.jpg": "xy43",
	"./productspic/entpic/ent-detail-34.jpg": "I4ci",
	"./productspic/entpic/ent-detail-35.jpg": "FKK3",
	"./productspic/entpic/ent-detail-36.jpg": "Mjyc",
	"./productspic/entpic/ent-detail-37.jpg": "ksDy",
	"./productspic/entpic/ent-detail-38.jpg": "1hnq",
	"./productspic/entpic/ent-detail-39.jpg": "ilAi",
	"./productspic/entpic/ent-detail-4.jpg": "9bgs",
	"./productspic/entpic/ent-detail-40.jpg": "PZsa",
	"./productspic/entpic/ent-detail-41.jpg": "JFe9",
	"./productspic/entpic/ent-detail-42.jpg": "UoEs",
	"./productspic/entpic/ent-detail-43.jpg": "TT8E",
	"./productspic/entpic/ent-detail-44.jpg": "anVK",
	"./productspic/entpic/ent-detail-45.jpg": "NDb0",
	"./productspic/entpic/ent-detail-46.jpg": "4nVp",
	"./productspic/entpic/ent-detail-47.jpg": "KZFw",
	"./productspic/entpic/ent-detail-48.jpg": "Rxiu",
	"./productspic/entpic/ent-detail-49.jpg": "VOXO",
	"./productspic/entpic/ent-detail-5.jpg": "RHgf",
	"./productspic/entpic/ent-detail-50.jpg": "qV9G",
	"./productspic/entpic/ent-detail-51.jpg": "u+wa",
	"./productspic/entpic/ent-detail-52.jpg": "oucY",
	"./productspic/entpic/ent-detail-53.jpg": "0pJE",
	"./productspic/entpic/ent-detail-54.jpg": "zyKH",
	"./productspic/entpic/ent-detail-55.jpg": "5QzH",
	"./productspic/entpic/ent-detail-56.jpg": "+NWP",
	"./productspic/entpic/ent-detail-57.jpg": "18Zk",
	"./productspic/entpic/ent-detail-58.jpg": "Pg1p",
	"./productspic/entpic/ent-detail-59.jpg": "2VXo",
	"./productspic/entpic/ent-detail-6.jpg": "+N+L",
	"./productspic/entpic/ent-detail-60.jpg": "RPqz",
	"./productspic/entpic/ent-detail-61.jpg": "Cs1d",
	"./productspic/entpic/ent-detail-62.jpg": "pEdg",
	"./productspic/entpic/ent-detail-63.jpg": "BhAe",
	"./productspic/entpic/ent-detail-64.jpg": "xxTw",
	"./productspic/entpic/ent-detail-65.jpg": "BjP+",
	"./productspic/entpic/ent-detail-66.jpg": "wdg3",
	"./productspic/entpic/ent-detail-67.jpg": "Hcfy",
	"./productspic/entpic/ent-detail-68.jpg": "WGv+",
	"./productspic/entpic/ent-detail-69.jpg": "wpGE",
	"./productspic/entpic/ent-detail-7.jpg": "90aQ",
	"./productspic/entpic/ent-detail-70.jpg": "fQ7d",
	"./productspic/entpic/ent-detail-71.jpg": "pS8j",
	"./productspic/entpic/ent-detail-72.jpg": "XM/a",
	"./productspic/entpic/ent-detail-73.jpg": "kkuH",
	"./productspic/entpic/ent-detail-74.jpg": "P2qU",
	"./productspic/entpic/ent-detail-75.jpg": "C0OB",
	"./productspic/entpic/ent-detail-76.jpg": "38zo",
	"./productspic/entpic/ent-detail-77.jpg": "yWqF",
	"./productspic/entpic/ent-detail-78.jpg": "P1c0",
	"./productspic/entpic/ent-detail-79.jpg": "ybxv",
	"./productspic/entpic/ent-detail-8.jpg": "nscr",
	"./productspic/entpic/ent-detail-80.jpg": "k1qY",
	"./productspic/entpic/ent-detail-81.jpg": "qnW5",
	"./productspic/entpic/ent-detail-82.jpg": "PK9e",
	"./productspic/entpic/ent-detail-83.jpg": "2XA4",
	"./productspic/entpic/ent-detail-84.jpg": "XDI+",
	"./productspic/entpic/ent-detail-85.jpg": "+A0U",
	"./productspic/entpic/ent-detail-86.jpg": "SDoI",
	"./productspic/entpic/ent-detail-87.jpg": "6n8C",
	"./productspic/entpic/ent-detail-88.jpg": "5NAT",
	"./productspic/entpic/ent-detail-89.jpg": "2ifc",
	"./productspic/entpic/ent-detail-9.jpg": "n8WM",
	"./productspic/entpic/ent-detail-90.jpg": "wRjH",
	"./productspic/entpic/ent-detail-91.jpg": "RQQD",
	"./productspic/entpic/ent-detail-92.jpg": "5nOx",
	"./productspic/entpic/ent-detail-93.jpg": "+hrQ",
	"./productspic/entpic/ent-detail-94.jpg": "LCvG",
	"./productspic/entpic/ent-detail-95.jpg": "rS34",
	"./productspic/entpic/ent-detail-96.jpg": "UUp/",
	"./productspic/entpic/ent-detail-97.jpg": "3RER",
	"./productspic/entpic/ent-detail-98.jpg": "vPKC",
	"./productspic/entpic/ent-detail-99.jpg": "jW2U",
	"./productspic/hotpic/hotLdetail.jpg": "4ACU",
	"./productspic/hotpic/hotRdetail.jpg": "VfQ/",
	"./productspic/hotpic/hotmiddetail.jpg": "6hfZ",
	"./productspic/hysteroscopepic/hysteroscope-1.jpg": "wzXE",
	"./productspic/hysteroscopepic/hysteroscope-2.jpg": "33Jm",
	"./productspic/hysteroscopepic/hysteroscope-3.jpg": "bliy",
	"./productspic/hysteroscopepic/hysteroscope-4.jpg": "Ce24",
	"./productspic/hysteroscopepic/hysteroscope-5.jpg": "B7uN",
	"./productspic/hysteroscopepic/hysteroscope-6.jpg": "FNMa",
	"./productspic/hysteroscopepic/hysteroscope-detail-1.jpg": "FkvI",
	"./productspic/hysteroscopepic/hysteroscope-detail-2.jpg": "9eXK",
	"./productspic/hysteroscopepic/hysteroscope-detail-3.jpg": "ZAkF",
	"./productspic/hysteroscopepic/hysteroscope-detail-4.jpg": "c0F5",
	"./productspic/hysteroscopepic/hysteroscope-detail-5.jpg": "ws1Y",
	"./productspic/hysteroscopepic/hysteroscope-detail-6.jpg": "7JOX",
	"./productspic/top-img.png": "3uTF",
	"./productspic/ureterpic/ureter-1.jpg": "AJu9",
	"./productspic/ureterpic/ureter-2.jpg": "M0U3",
	"./productspic/ureterpic/ureter-3.jpg": "lAFw",
	"./productspic/ureterpic/ureter-4.jpg": "FvFs",
	"./productspic/ureterpic/ureter-detail-1.jpg": "gwnR",
	"./productspic/ureterpic/ureter-detail-2.jpg": "Hbwo",
	"./productspic/ureterpic/ureter-detail-3.jpg": "nD2z",
	"./productspic/ureterpic/ureter-detail-4.jpg": "HAOd",
	"./swiperpic/homevideo.mp4": "X12u",
	"./swiperpic/videotext.png": "U0Zh",
	"./swiperpic/videotextEn.png": "O0VY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 51